import { render, staticRenderFns } from "./FormPurchaseOtherInvoice.vue?vue&type=template&id=15b4cd4b"
import script from "./FormPurchaseOtherInvoice.vue?vue&type=script&lang=js"
export * from "./FormPurchaseOtherInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports